/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Quick_Practice_Which_FirstInputs */



/**
* | output |
* | --- |
* | "Which conversation should I practise first?" |
*
* @param {Chat_Quick_Practice_Which_FirstInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_quick_practice_which_first = /** @type {((inputs?: Chat_Quick_Practice_Which_FirstInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Quick_Practice_Which_FirstInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Welk gesprek kan ik best eerst oefenen?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quelle conversation devrais-je pratiquer en premier ?")
	return /** @type {LocalizedString} */ ("Which conversation should I practise first?")
});